import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		ActeursColors: {},
		GrandePeriode: [],
		ActiveGrandePeriode: 0,
		ActivePeriode: 0,
		Listes: [],
		isMobile: false
	},
	getters: {
		getGrandesPeriodes(state: any): Array<any> {
			return state.GrandePeriode;
		},
		getActiveGrandePeriodeIndex(state: any): any {
			return state.ActiveGrandePeriode;
		},
		getActiveGrandePeriode(state: any): any {
			return state.GrandePeriode[state.ActiveGrandePeriode];
		},
		getActivePeriode(state: any): any {
			return state.GrandePeriode[state.ActiveGrandePeriode].periodes[state.ActivePeriode];
		},
		getActivePeriodeIndex(state: any): any {
			return state.ActivePeriode;
		},
		getActeurColor(state: any) {
			return (acteur: string): string | undefined => {
				return state.ActeursColors[acteur];
			};
		},
		getIsFirstGrandePeriode(state: any): boolean {
			return state.ActiveGrandePeriode === 0;
		},
		getIsLastGrandePeriode(state: any): boolean {
			return state.ActiveGrandePeriode === state.GrandePeriode.length - 1;
		},
		getListeById(state: any) {
			return (id: string): string | undefined => {
				return state.Listes[id];
			};
		},
		getIsMobile(state: any) {
			return state.isMobile;
		},
		getHasOpenedPopup(state: any) {
			for (let key in state.Listes) {
				if (state.Listes.hasOwnProperty(key)) {
					if (state.Listes[key].opened === true) {
						return true;
					}
				}
			}

			return false;
		}
	},
	mutations: {
		initData(state: any, data: any): void {
			state.GrandePeriode = data.GrandePeriode;
			state.ActeursColors = data.ActeursColors;

			for (let key in data.Listes) {
				if (data.Listes.hasOwnProperty(key)) {
					data.Listes[key].opened = false;
				}
			}

			state.Listes = data.Listes;
		},
		setActiveGrandePeriode(state: any, nom: any): void {
			state.ActiveGrandePeriode = state.GrandePeriode.findIndex((item: { nom: string; }) => item.nom === nom);
			state.ActivePeriode = 0;
		},
		setActiveGrandePeriodeIndex(state: any, index: number): void {
			state.ActiveGrandePeriode = index;
			state.ActivePeriode = 0;
		},
		setNextActiveGrandePeriode(state: any): void {
			if (state.ActiveGrandePeriode < state.GrandePeriode.length - 1) {
				state.ActiveGrandePeriode++;
			}

			state.ActivePeriode = 0;
		},
		setPreviousActiveGrandePeriode(state: any): void {
			if (state.ActiveGrandePeriode > 0) {
				state.ActiveGrandePeriode--;
			}

			state.ActivePeriode = 0;
		},
		setActivePeriode(state: any, nom: any): void {
			let periodes = state.GrandePeriode[state.ActiveGrandePeriode].periodes;
			state.ActivePeriode = periodes.findIndex((item: { nom: string; }) => item.nom === 'nom');
		},
		setNextActivePeriode(state: any): void {
			if (state.ActivePeriode + 1 !== state.GrandePeriode[state.ActiveGrandePeriode].periodes.length) {
				state.ActivePeriode++;
			}
		},
		setPreviousActivePeriode(state: any): void {
			if (state.ActivePeriode > 0) {
				state.ActivePeriode--;
			}
		},
		setActivePeriodeIndex(state: any, index: number): void {
			state.ActivePeriode = index;
		},
		setIsMobile(state: any, isMobile: boolean): void {
			state.isMobile = isMobile;
		},
		setPopupOpenState(
			state: any,
			data: { listId: string; state: boolean }
		): void {
			state.Listes[data.listId].opened = data.state;
		}
	},
	actions: {}
});
